// Generated by `yarn tokens:import --aos-ds` from the Figma component "Label" (6987:4469). Do not edit.
//
// This component is composed rather than a variant matrix, so the contract
// carries the tokens its Figma node binds and the component is written by hand.
// The spec asserts the two agree exactly — see dsComposedModule in
// packages/aos-ui-universal/scripts/tokens-import.mjs for why.

export type ContractProp =
    | { kind: 'text' }
    | { kind: 'boolean' }
    | { kind: 'instance_swap' }
    // A slot is also a declared property, not only a node in the tree.
    | { kind: 'slot' }
    | { kind: 'variant'; values: readonly string[] }

export type TokenSubstitution = { was: string; now: string; value: number; why: string }

export type ContractComposition = { component: string; variants: readonly string[] }

/** `variable: null` is a removal: the main component binds it, this instance does not. */
export type InstanceOverride = {
    path: string
    property: string
    variable: string | null
    was: string | null
}

/** Where the caller puts content — `children`, or a prop per named slot. */
export type ContractSlot = { path: string; name: string }

export const labelContract = {
    component: 'Label',
    nodeId: '6987:4469',
    section: '[Web] Primitives',
    textStyleIds: ['S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,'],
    figmaTokens: ['content/default', 'small-compact/2xs', 'small-compact/xs'],
    // What the bound text style is made of. On record, not asserted against
    // classes: these reach the page as Typography's variant, not as a class.
    textTokens: ['family/family', 'line-height/p2', 'size/p2', 'weight/regular'] as string[],
    // Inherited from the components this one instantiates. Verified in their
    // own contracts, so drift.ts subtracts these rather than counting them here.
    childTokens: [] as string[],
    composes: [] as ContractComposition[],
    overrides: [] as InstanceOverride[],
    slots: [] as ContractSlot[],
    props: {
        label: { kind: 'text' },
        showRequiredField: { kind: 'boolean' },
    },
    substituted: [] as TokenSubstitution[],
} as const
